import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';

export const patientHashInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(StorageService);
  const hash = storage.getHash();
  const forreview = storage.getForReview();
  if (hash) {
    const clonedRequest = req.clone({
      setHeaders: {
        'X-Patient-Hash': hash,
        ...(forreview && { 'X-For-Review': 'true' })
      }
    });
    return next(clonedRequest);
  }

  return next(req);
};
